const { REACT_APP_HERMES_URL, REACT_APP_COGNITO_GROUPS_ALLOWED } = process.env;
export const HERMES_URL = REACT_APP_HERMES_URL;
export const COGNITO_GROUPS_ALLOWED = REACT_APP_COGNITO_GROUPS_ALLOWED;
export const primaryColor = "#3b8ba7";
export const secondaryColor = "#90cb7c";
export const authRoutes = ["login", "forgotPassword"];
